import { TeaserCard as TeaserComponent } from '@almbrand/teasercard';
import { mapCtaProps } from 'common/buttonUtils';
import { GridCellComponent } from 'components/4-habitats/ContainerLayout/GridCellComponent';
import { useModal } from 'hooks/useModal';
import styles from './TeaserCardComponent.module.scss';

export interface TeaserCardProps {
	icon: Image;
	content?: string;
	backgroundColor?: BackgroundColor;
	fields?: MainArea;
	ctaGroupConfiguration: {
		ctaGroup: {
			items: CtaProps[];
		};
	};
}

export const TeaserCard: React.FC<TeaserCardProps> = ({
	icon,
	content,
	backgroundColor,
	fields,
	ctaGroupConfiguration: { ctaGroup },
}) => {
	const { displayModal } = useModal();

	const getModalContent = (modalContent: ModalComponentProps) => {
		const { title, content, fields } = modalContent;
		displayModal(
			title,
			fields.items.map((subItem, index) => (
				<GridCellComponent
					component={subItem}
					key={index}
					applySpacings
					noGutter
					className={subItem?.content?.contentType === 'TeaserCardBlock' && styles.TeaserCard__modalContent}
				/>
			)),
			content
		);
	};

	const openModal = () => {
		const modalItems = fields?.items?.map((subItem) => subItem?.content as ModalComponentProps);
		modalItems?.forEach((modalContent) => getModalContent(modalContent));
	};

	return (
		<TeaserComponent
			backgroundColor={backgroundColor?.cssClass}
			icon={{
				url: icon?.url,
				altText: icon?.properties?.altText,
			}}
			content={content}
			ctaGroupProps={mapCtaProps(ctaGroup.items, openModal, styles.TeaserCard__ctaGroup)}
		/>
	);
};
